import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20" data-id="element-199">
      {/* Background styling - CSS only luxury gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-soft-black via-brand-black to-brand-black z-0" data-id="element-200" />

      {/* Decorative elements */}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" data-id="element-201">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-brand-gold to-transparent" data-id="element-202" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-brand-gold to-transparent" data-id="element-203" />
        <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-204" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-206">
          <span className="inline-block py-1 px-3 rounded-full border border-brand-gold/30 text-brand-gold text-xs font-medium tracking-widest uppercase mb-8 bg-brand-gold/5 backdrop-blur-sm" data-id="element-207">
            Miami's Premier Aesthetic Clinic
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-brand-white leading-tight mb-6" data-id="element-208">
            Luxury Medical Spa Treatments Designed for{' '}
            <span className="text-brand-gold italic" data-id="element-209">Real Results</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-champagne-light/80 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-210">
            Personalized aesthetic treatments in Miami designed to help you look
            refreshed, confident, and naturally beautiful.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-211">
            <button onClick={() => document.getElementById('appointment')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto px-8 py-4 border border-transparent text-base font-medium rounded-sm text-brand-black bg-brand-gold hover:bg-brand-gold-light transition-all duration-300 shadow-gold-glow cursor-pointer" data-id="element-212">
              Book Consultation
            </button>
            <button onClick={() => document.getElementById('appointment')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto px-8 py-4 border border-brand-gold text-brand-gold text-base font-medium rounded-sm hover:bg-brand-gold/10 transition-all duration-300 bg-transparent cursor-pointer" data-id="element-213">
              Request Appointment
            </button>
          </div>

          <p className="text-sm text-brand-champagne-light/50 font-light" data-id="element-214">
            Boutique med spa in Miami offering personalized beauty and wellness
            treatments.
          </p>
        </motion.div>
      </div>
    </section>;
}